export const isTokenValid = (token: string | null | undefined) => {
  if (!token) return false;

  const decodedToken = JSON.parse(atob(token.split(".")[1]));

  return decodedToken.exp > Date.now() / 1000;
};
